import axios from 'axios';

export const meiliAxios = axios.create({
  baseURL: process.env.REACT_APP_MEILI_SERVER_URL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_MEILI_SERVER_API_KEY}`,
  },
});

meiliAxios.interceptors.response.use((res) => {
  return res.data;
});
